//
// CrosstabPickButtonType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var CrosstabPickButtonType = {
    CROSSTAB_EXPAND_BUTTON:0,
    CROSSTAB_COLLAPSE_BUTTON:1,
    CROSSTAB_DRILLDOWN_BUTTON:2,
    CROSSTAB_PAGE_UP_BUTTON:3,
    CROSSTAB_PAGE_UP_END_BUTTON:4,
    CROSSTAB_PAGE_DOWN_BUTTON:5,
    CROSSTAB_PAGE_DOWN_END_BUTTON:6,
    NONE:7
};
export default CrosstabPickButtonType;
